import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  LocalDataTrack,
  LocalParticipant,
  createLocalTracks,
} from "twilio-video";
import Video from "twilio-video";
import Lobby from "./lobby";
import Room from "./room";
import { useDispatch, useSelector } from "react-redux";
import joinCall from "../../service/api/twilio-video/joinVideo";
import io from "socket.io-client";

import { LocalTrack } from "twilio-video";
import {
  drawDisable,
  setRoleRedux,
  setTotalCallTimeRedux,
  setUserDetails,
} from "../../feature/userData/userData";
import { saveRating } from "../../service/api/user/saveRating";

import updateAvailabilityApi from "../../service/api/user/updateAvailability";
import { userById } from "../../service/api/user/userById";
import { getCountryCode } from "../../service/api/countryCode/countryCode";
import { setCountryArray } from "../../feature/countryArray/countryArray";
import { useLocation, useNavigate } from "react-router-dom";
import { saveCallDurationApi } from "../../service/api/video/saveCallDuration";
import { getTwilioTrackNames } from "./twilioTrackNames";

const VideoChat = ({ }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {

    userName,
    role,
    recordingPermission
  } = useSelector((state) => state.user);
  const { authorized, } = useSelector((state) => state.auth);

  const location = useLocation();

  const params = new URLSearchParams(location.search);

  const page = params.get("page");
  const nestedQuery = page?.split("?")[1];

  const guestHomeOwnerId = new URLSearchParams(nestedQuery).get("guestHomeOwnerId");

  const [remoteUrl, setRemoteUrl] = useState("");
  const [name, setName] = useState(userName ? userName : "Customer");
  const [roomName, setRoomName] = useState("");
  const [room, setRoom] = useState(null);
  const [connecting, setConnecting] = useState(false);
  const [token, setToken] = useState("");
  const [errorText, setErrorText] = useState("");
  const [errorConnecting, setErrorConnecting] = useState(false);
  const [limExc, setLimExc] = useState(false);
  const [parText, setParText] = useState("");

  const [ratingDialog, setRatingDialog] = useState(false);
  const [ratingValue, setRatingValue] = useState(0);
  const [feedbackMessage, setFeedbackMessage] = useState("");
  const [remoteUserId, setRemoteUserId] = useState("");
  const [ratingValueEmpty, setRatingValueEmpty] = useState(false);
  const [camPermission, setCamPermission] = useState(false);
  const [cameraIsThere, setCameraIsThere] = useState(true);
  const [cameraFacingMode, setCameraFacingMode] = useState("environment");

  const [responceMsg, setResponceMsg] = useState("");
  const [toasterType, setToasterType] = useState();
  const [handleToaster, setHandleToaster] = useState(false);
  const [joinCallResponse, setJoinCallResponse] = useState();
  const [startTimer, setStartTimer] = useState(false)
  const [selectedTracks, setSelectedTracks] = useState({ audioTrack: null, videoTrack: null });
  const [participantNameArr, setParticipantNameArr] = useState([])

  const socketRef = useRef(null); // Initialize socketRef using useRef()

  useEffect(() => {
    // Initialize the socket connection
    socketRef.current = io(process.env.REACT_APP_ENV, {
      query: {
        user_id_ids: localStorage.getItem("user_id") || "",
        device_type_chr: "BROWSER",
      },
    });

    socketRef.current.on("connect", () => {
      console.log("Connected to IB WebSocket");
    });

    socketRef.current.on("message", (message) => {
      console.log("Received message: Socket", message);
    });

    socketRef.current.on("server_response", (payload) => {
      console.log("Received server response:", payload);
      if (payload.data.notification_type) {
        setParticipantNameArr(payload.data.participant_names)
      }
    });

    // Cleanup function to disconnect the socket on component unmount
    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
      }
    };
  }, []);

  const sendEventToSocket = (eventName, data) => {
    if (socketRef.current && socketRef.current.connected) {
      socketRef.current.emit(eventName, data);
      console.log(`Event '${eventName}' sent to server with data:`, data);
    } else {
      console.log("Socket is not connected.");
    }
  };

  // Callback function to be passed to the child to receive the selected devices
  const handleDeviceSelection = ({ audioDeviceId, videoDeviceId }) => {
    // console.log("audio -- ",audioDeviceId , "video--",videoDeviceId)
    // createLocalTracks({
    //   audio: { deviceId: audioDeviceId ? { exact: audioDeviceId } : undefined },
    //   video: { facingMode: {
    //     ideal: role == 2 ? "environment" : "user",
    //   }, }
    // }).then(localTracks => {
    //   const audioTrack = localTracks.find(track => track.kind === 'audio');
    //   const videoTrack = localTracks.find(track => track.kind === 'video');
    //   setSelectedTracks({ audioTrack, videoTrack });
    // }).catch(error => console.error('Error creating local tracks:', error));
  };
  // useEffect(() => {
  //   if (parseInt(localStorage.getItem("user_role")) == 2) {
  //     setCameraFacingMode('environment');
  //   }
  //   else if (parseInt(localStorage.getItem("user_role")) == 1
  //     || parseInt(localStorage.getItem("user_role")) == 3
  //     || parseInt(localStorage.getItem("user_role")) == 4) {
  //     setCameraFacingMode('user');
  //   } else {
  //     setCameraFacingMode('environment');
  //   }

  // }, [])

  const handleUsernameChange = useCallback((event) => {
    setErrorText("");
    setName(event.target.value);
  }, []);

  const handleRoomNameChange = useCallback((event) => {
    setRoomName(event.target.value);
  }, []);

  function handleAlert() {
    setLimExc(false);
  }

  useEffect(() => {
    localStorage.setItem("ChargeMe", 0)
    navigator.mediaDevices
      .enumerateDevices()
      .then(function (devices) {
        // Check if any of the devices are cameras
        setCameraIsThere(true);
        // Log the result to the console
      })
      .catch(function (error) {
        setCameraIsThere(false);
      });
  }, []);
  useEffect(() => {
    if (authorized) {
      setName(userName);
    }
  }, [userName]);

  const handleSubmit = () => {

    if (name) {
      setConnecting(true);
      var myUserId = "";
      if (localStorage.getItem("user_id")) {
        myUserId = localStorage.getItem("user_id");
      }
      let details = {
        joinee_name_chr: name,
        user_id_ids: myUserId || guestHomeOwnerId || "",
        video_token_chr: localStorage.getItem("roomCode") || "",
        trigger_call_flag: 1,
        role_id_int: parseInt(localStorage.getItem("user_role")) || 0,
        recording_confirmation_flag: recordingPermission ? 1 : 0,
      };

      dispatch(
        joinCall(
          details,
          (res) => {

            dispatch(setTotalCallTimeRedux(res.data.total_call_time_limit_in_sec))
            localStorage.setItem("call_log_id", res.data.call_log_id_ids || "");
            localStorage.setItem("ticket_id", res.data.ticket_id_ids);
            localStorage.setItem("triggerFlag", 0);
            setJoinCallResponse(res.data);
            // localStorage.setItem("user_role",res.data.local_user_role_id)
            setRemoteUrl(res.data.remote_user_preferred_profile_picture_url);

            setRemoteUserId(res.data.remote_user_id);

            setToken(res.data.twilio_token);
            setRoomName(res.data.roomName);
            if (res.data.is_sender_flag == 1) {
              setCameraFacingMode("user");
            } else {
              setCameraFacingMode("environment");
            }

            if (!authorized) {
              localStorage.setItem(
                "access_token",
                res.data.guest_user_access_token
              );
            }
          },
          (err) => {
            try {
              if (err?.status === 417) {

                setStartTimer(true)
                setLimExc(true);
                setParText(err.data.message);
                setConnecting(false);

              } else {
                setLimExc(true);
                setParText(err.data.message);
                setConnecting(false);
              }
            }
            catch {

            }

          }
        )
      );
    } else {
      setErrorText("Please enter name to join call");
    }
  };


  useEffect(() => {
    console.log("camera", cameraFacingMode, selectedTracks)
    if (token) {
      const trackNames = getTwilioTrackNames(role);
      console.log("Joining room with token:", token);
      createLocalTracks({
        audio: { name: trackNames.microphone },
        video: {
          name: trackNames.camera,
          facingMode: { ideal: cameraFacingMode },
          focusMode: "continuous"
        },
      })
        .then((localTracks) => {
          console.log(localTracks, "LocalTracks ")
          return Video.connect(token, {
            roomName: roomName,
            tracks: [...localTracks, new LocalDataTrack({ name: trackNames.data })],
            networkQuality: {
              local: 3, // LocalParticipant's Network Quality verbosity [1 - 3]
              remote: 3 // RemoteParticipants' Network Quality verbosity [0 - 3]
            },
            automaticSubscription: true
          });
        })
        .then((room) => {


          room.localParticipant.setNetworkQualityConfiguration({
            local: 3,
            remote: 3
          });

          setRoom(room);
          setConnecting(false);
          room.setMaxListeners(1);

          const eventData =
          {
            call_id_ids: joinCallResponse.call_log_id_ids,
            remote_user_id_ids: joinCallResponse.remote_user_id,
            action: "connect"
          };
          sendEventToSocket("call_event", eventData);

        })
        .catch((error) => {
          checkPermissionAndJoin(error)
        });

    }
  }, [token, role]);

  function checkPermissionAndJoin(error) {
    setCamPermission(true)
    setConnecting(false)
    console.log(error)
  }

  function resetMyRoom() {
    if (name) {
      setConnecting(true);
      var myUserId = "";
      if (localStorage.getItem("user_id")) {
        myUserId = localStorage.getItem("user_id");
      }
      let details = {
        joinee_name_chr: name,
        user_id_ids: myUserId || guestHomeOwnerId || "",
        video_token_chr: localStorage.getItem("roomCode") || "",
        trigger_call_flag: 0,
        role_id_int: parseInt(localStorage.getItem("user_role")) || 0,
        recording_confirmation_flag: recordingPermission ? 1 : 0,
      };

      dispatch(
        joinCall(
          details,
          (res) => {

            dispatch(setTotalCallTimeRedux(res.data.total_call_time_limit_in_sec))
            localStorage.setItem("call_log_id", res.data.call_log_id_ids);
            localStorage.setItem("ticket_id", res.data.ticket_id_ids);
            localStorage.setItem("triggerFlag", 0);
            setJoinCallResponse(res.data);
            // localStorage.setItem("user_role",res.data.local_user_role_id)
            setRemoteUrl(res.data.remote_user_preferred_profile_picture_url);

            setRemoteUserId(res.data.remote_user_id);

            setToken(res.data.twilio_token);
            setRoomName(res.data.roomName);
            if (res.data.is_sender_flag == 1) {
              setCameraFacingMode("user");
            } else {
              setCameraFacingMode("environment");
            }

            if (!authorized) {
              localStorage.setItem(
                "access_token",
                res.data.guest_user_access_token
              );
            }
          },
          (err) => {
            try {
              if (err?.status === 417) {

                setStartTimer(true)
                setLimExc(true);
                setParText(err.data.message);
                setConnecting(false);

              } else {
                setLimExc(true);
                setParText(err.data.message);
                setConnecting(false);
              }
            }
            catch {

            }

          }
        )
      );
    } else {
      setErrorText("Please enter name to join call");
    }
  }

  const handleLogout = async () => {

    dispatch(drawDisable());
    const eventData =
    {
      call_id_ids: joinCallResponse.call_log_id_ids,
      remote_user_id_ids: joinCallResponse.remote_user_id,
      action: "disconnect"
    };
    sendEventToSocket("call_event", eventData);

    if (room) {
      for (const trackPub of room.localParticipant.tracks.values()) {
        if (trackPub.kind === "video" || trackPub.kind === "audio") {
          trackPub.track.stop();
        }
      }
    }
    if (remoteUserId.length > 0) {
      setRatingDialog(true)

      await room?.disconnect()
      localStorage.setItem("remoteUserId", remoteUserId);
      // navigate("/callRating");


      setRoom(null)
    } else {
      await room?.disconnect()
      setRatingDialog(true)
      setRoom(null)
      const eventData =
      {
        call_id_ids: joinCallResponse.call_log_id_ids,
        remote_user_id_ids: joinCallResponse.remote_user_id,
        action: "disconnect"
      };
      sendEventToSocket("call_event", eventData);
      // navigate("/dashboard")
    }


  };

  function saveCallDuration() {

  }

  function saveCallDurationByPro() {
    const data = new FormData()
    if (joinCallResponse.is_sender_flag == 0) {
      data.append("user_id_ids", localStorage.getItem("user_id") || "")
    } else {
      data.append("user_id_ids", remoteUserId || "")
    }

    data.append("call_log_id_ids", joinCallResponse?.call_log_id_ids)
    data.append("joinee_name_chr", name)
    data.append("call_duration_in_second", localStorage.getItem("timeUsedInSecondsReset"))

    console.log('called from videoCall!!!')

    dispatch(saveCallDurationApi(data, (res) => {
      console.log(res)
    }, (err) => {
      console.log(err)
    }))
  }
  function handleCamPer() {
    setCamPermission(false);
    setStartTimer(false)
  }

  function disconnectFn() {
    if (room) {
      const eventData =
      {
        call_id_ids: joinCallResponse.call_log_id_ids,
        remote_user_id_ids: joinCallResponse.remote_user_id,
        action: "disconnect"
      };
      sendEventToSocket("call_event", eventData);
      room.localParticipant.tracks.forEach(async (trackPub) => {
        if (trackPub.kind === "video") {
          trackPub.track.stop();
        }
        if (trackPub.kind === "audio") {
          trackPub.track.stop();
        }
        if (trackPub.kind === "data") {
          // trackPub.track.stop();
        }
      }).then(() => {
        // handleSubmit()
      })

    }
  }


  useEffect(() => {
    dispatch(drawDisable());

    if (authorized) {
      let user = {
        user_id_ids: localStorage.getItem("user_id"),
        role_id_int: localStorage.getItem("roleId"),
        user_impersonate_flag: 0,
      };
      dispatch(
        userById(user, (res) => {
          dispatch(setUserDetails(res.data.data));
        })
      );
    }

    let details = {};
    dispatch(
      getCountryCode(
        details,
        (res) => {
          dispatch(setCountryArray(res.data));
        },
        (err) => { }
      )
    );
  }, []);

  useEffect(() => {
    if(!localStorage.getItem("roomCode")){
      navigate("/");
    }

    return () => {

      window.location.reload();
    };
  }, []);





  function handleRatingChange(event, newValue) {
    setRatingValue(event.target.value);
    setRatingValueEmpty(false);
  }

  function closeRatingDialog() {
    if (ratingValue > 0) {
      setRatingDialog(false);
      var data = {
        user_id_ids: remoteUserId === null ? -1 : remoteUserId,
        call_log_id_ids: localStorage.getItem("call_log_id"),
        rating_value_int: ratingValue,
        comment_chr: feedbackMessage,
        given_by_name_chr: userName,
      };
      dispatch(
        saveRating(
          data,
          (res) => {
            setRatingValue(0);
            setFeedbackMessage("");

            setResponceMsg(res.data.message);
            setToasterType("success");

            setHandleToaster(true);
            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);

            window.close();
          },
          (res) => {
            setResponceMsg(res.data.message);
            setToasterType("error");

            setHandleToaster(true);
            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);
          }
        )
      );
    } else {
      setRatingValueEmpty(true);
    }
  }

  function handleFeedbackMessage(e) {
    setFeedbackMessage(e.target.value);
  }

  function closeRatingDialogOnly() {
    setRatingDialog(false);
    window.close();
  }

  useEffect(() => {
    // return () => {

    //   navigate("/dashboard");
    //   window.location.reload()

    //   window.addEventListener("beforeunload", () => {


    //   });
    // };
  }, []);
  function handleTimerStop() {
    setLimExc(false)
    setStartTimer(false)
    setConnecting(false)
  }
  function ReconnectingAfterTimeout() {
    let attempts = 0;
    const maxAttempts = 3;

    const intervalId = setInterval(() => {
      console.log("Interval running");

      var myUserId = localStorage.getItem("user_id") || "";

      let details = {
        joinee_name_chr: name,
        user_id_ids: myUserId || guestHomeOwnerId || "",
        video_token_chr: localStorage.getItem("roomCode") || "",
        trigger_call_flag: 0,
        role_id_int: parseInt(localStorage.getItem("user_role")) || 0,
        recording_confirmation_flag: recordingPermission ? 1 : 0,
      };

      dispatch(
        joinCall(
          details,
          (res) => {
            if (res.status === 200) {
              dispatch(setTotalCallTimeRedux(res.data.total_call_time_limit_in_sec))
              localStorage.setItem("call_log_id", res.data.call_log_id_ids);
              localStorage.setItem("ticket_id", res.data.ticket_id_ids);
              localStorage.setItem("triggerFlag", 0);
              setJoinCallResponse(res.data);
              setRemoteUrl(res.data.remote_user_preferred_profile_picture_url);
              setRemoteUserId(res.data.remote_user_id);
              setToken(res.data.twilio_token);
              setRoomName(res.data.roomName);

              if (res.data.is_sender_flag == 1) {
                setCameraFacingMode("user");
              } else {
                setCameraFacingMode("environment");
              }

              if (!authorized) {
                localStorage.setItem(
                  "access_token",
                  res.data.guest_user_access_token
                );
              }

              clearInterval(intervalId);
              console.log("Condition satisfied. Interval stopped.");
            }
          },
          (err) => {
            // Handle error if needed
          }
        )
      );

      attempts += 1;
      if (attempts >= maxAttempts) {
        clearInterval(intervalId);
        window.location.reload()
        console.log("Maximum attempts reached. Interval stopped.");
      }
    }, 5000);

    // Optional: Return a function to clear the interval manually if needed
    return () => clearInterval(intervalId);
  }


  const handleUpdateForEstimationReport = () => {
    const eventData =
    {
      call_id_ids: joinCallResponse.call_log_id_ids,
      remote_user_id_ids: joinCallResponse.remote_user_id,
      action: "disconnect"
    };
    sendEventToSocket("call_event", eventData);
  }


  let render;
  if (room) {
    render = (
      <Room
        tokenRoom={token}
        roomName={roomName}
        room={room}
        remoteU={remoteUrl}
        handleLogout={handleLogout}
        remoteParId={remoteUserId}
        joinCallRes={joinCallResponse}
        reconnectRoomFn={disconnectFn}
        ReconnectingAfterTimeout={ReconnectingAfterTimeout}
        saveDurationByPro={() => {
          saveCallDurationByPro()
        }}
        saveDurationByCustomer={() => {
          saveCallDuration()
        }}
        disconnectMyRoom={resetMyRoom}
      />
    );
  } else {
    render = (
      <Lobby

        name={name}
        roomName={roomName}
        handleUsernameChange={handleUsernameChange}
        handleRoomNameChange={handleRoomNameChange}
        handleSubmit={handleSubmit}
        connecting={connecting}
        error={errorText}
        participantText={parText}
        limitExceedParticipant={limExc}
        handleParticipantAlert={handleAlert}
        ratingDialogValue={ratingDialog}
        closeRatingDialogFn={closeRatingDialog}
        handleRatingOnChange={handleRatingChange}
        handleRatingValue={ratingValue}
        handleFeedbackMessageChange={handleFeedbackMessage}
        handleFeedbackMessageValue={feedbackMessage}
        closeRatingDialogFnOnly={closeRatingDialogOnly}
        remoteParId={remoteUserId}
        ratingValueEmp={ratingValueEmpty}
        cameraPermission={camPermission}
        handleCameraClose={handleCamPer}
        responceMsg={responceMsg}
        toasterType={toasterType}
        handleToaster={handleToaster}
        handleTimerStop={handleTimerStop}
        startTimeFlow={startTimer}
        handleDeviceSelection={handleDeviceSelection}
        participantNameArr={participantNameArr}
        joinCallRes={joinCallResponse}
        handleUpdateForEstimationReport={handleUpdateForEstimationReport}
      />
    );
  }
  return render;
};

export default VideoChat;
